import Decimal from 'decimal.js';

/** Empty / cleared currency inputs from fields often arrive as `""` — Decimal rejects those. */
function toDollarDecimal(value: string | number): Decimal {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return new Decimal(0);
    }
    return new Decimal(trimmed);
  }
  if (typeof value === 'number' && !Number.isFinite(value)) {
    return new Decimal(0);
  }
  return new Decimal(value);
}

/**
 * Converts a dollar amount to cents (×100) with Decimal.js.
 * @param decimalPlaces - When set, rounds the cent amount to this many decimal places; otherwise rounds to whole cents.
 */
export function dollars2cents(
  value: string | number,
  decimalPlaces?: number,
  unlimitedDecimals?: boolean,
): number {
  const scaled = toDollarDecimal(value).times(100);
  if (unlimitedDecimals) {
    return scaled.toNumber();
  }
  if (decimalPlaces === undefined) {
    return scaled.round().toNumber();
  }
  return scaled.toDecimalPlaces(decimalPlaces).toNumber();
}

/** Same scaling as {@link dollars2cents}, but returns a `Decimal` (e.g. for `abs` / `neg`). */
export function dollars2centsDecimal(
  value: string | number,
  decimalPlaces?: number,
): Decimal {
  const scaled = toDollarDecimal(value).times(100);
  if (decimalPlaces === undefined) {
    return scaled.round();
  }
  return scaled.toDecimalPlaces(decimalPlaces);
}
